module.exports = __webpack_public_path__ + "img/house-door.95783fcb.svg";